import React from "react"
import { graphql } from "gatsby"

import "../utils/fragments"
import Layout from "../components/layout"
import SEO from "../components/seo"

import PageBuilderRows from '../components/page-builder'
import FootNote from '../components/ui/FootNote';

const IndexPage = ({ data }) => (
  <Layout>
    <SEO title={data.wpgraphql.page.page_builder.siteTitle} favicon={data.wpgraphql.page.page_builder.favicon} />
    <PageBuilderRows data={data.wpgraphql.page.page_builder} />
    <FootNote footnote={data.wpgraphql.page.page_builder.footnote} showCredits={data.wpgraphql.page.page_builder.showCredits} />
  </Layout>
)

export default IndexPage


export const data = graphql`
  query {
    wpgraphql {
      page: pageBy(uri: "esma-3d-summer") {
        ... pageFields
      }
    }
  }
`
